import type { UserInfo } from '@mcex/types';

export enum GRANT_TYPEENUM {
  LOGIN = 'password',
  REFRESH = 'refresh_token',
}
/**
 * @description: Login interface parameters
 */
export interface LoginParams {
  businessType: string;
  businessKey: string;
  username: string;
  password: string;
  client_id: string;
  grant_type: GRANT_TYPEENUM;
  captchaVerification: string;
}
export interface SinUpParams {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
}

export interface resetPassParams {
  email: string;
  otp: string;
  password: string;
  username: string;
}
export interface LoginIdsParams {
  email: string;
  otp: string;
}

export interface LoginIdsItem {
  email: string;
  memberCode: string;
  memberName: string;
  username: string;
}
export interface LoginIdsResult {
  code: Number;
  data: LoginIdsItem[];
  msg: string;
}
export interface RoleInfo {
  roleName: string;
  value: string;
}

/**
 * @description: Login interface return value
 */
export interface LoginResultModel {
  code: Number;
  data: {
    access_token: string;
    expires_in: Number;
    refresh_expires_in: Number;
    refresh_token: string;
    token_type: string;
  };
}

/**
 * @description: Get user information return value
 */
export type GetUserInfoModel = UserInfo;

export interface RefreshParams {
  refresh_token: string;
  client_id: string;
  grant_type: GRANT_TYPEENUM;
}

export interface CheckAndGetAccountsParams {
  usernameOrEmail: string;
}
